<template>
  <!-- 导览 -->
  <div class="guide-wrapper w-100">
    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :data="configData" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
            <el-button type="primary">
              <svg-icon icon-class="add" />&nbsp;导入值班表
            </el-button>
          </el-upload>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column  label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column  prop="attName" label="值班表名称" show-overflow-tooltip>
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="preview(scope.row)">{{scope.row.attName}}</a>
            </template>
          </el-table-column>

          <!-- 操作 -->
          <el-table-column  fixed="right" label="操作" min-width="20%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="download(scope.row)">下载</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  data() {
    return {
      configData: {
        tableName: 'zbb'
      },
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
    }
  },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.$http
        .get('/attach/getFileList', {
          ...this.form,
          ...this.listQuery,
          type: 'zbb'
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            if (res.result && res.result.result) {
              this.tableData = res.result.result.records
              this.total = res.result.result.total
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },

    preview(item) {
      window.open('/singleMuseum/repair/bsRepairSpecification/view?id=' + item.attId + '&edit=false&userId=admin&userName=admin', '_blank')
    },


    download(item) {
      location.href = '/singleMuseum/attach/downloadFile?attachmentId=' + item.attId
    },

    // 删除
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$http
            .delete('/attach/deleteAttachment', {
              id: obj.attId
            })
            .then(res => {
              if (res.success) {
                this.$message.success('值班表删除成功')
                this.getData()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },

    beforeAvatarUpload(file) { },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.getData()
      } else {
        this.$message.error(res.message)
      }
    },


    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

  },
  created() {
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.guide-wrapper {
  /deep/ .el-form-item {
    .el-form-item__content {
      margin-left: 0 !important;
    }

    &.avatar-uploader-form {
      display: flex;
      flex-direction: column;
      /deep/ .el-form-item__content {
        margin-left: 0 !important;
      }

      .avatar-uploader {
        width: 50%;
        border: 1px dashed #8c939d;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .el-upload {
          width: 100%;
        }
        .el-icon-plus {
          font-size: 20px;
        }

        .el-upload__text {
          line-height: 1;
        }
      }
    }
  }
}
</style>